import React from 'react'
import { StyledInput } from './Input.styles'
import type { InputProps } from './Input.types'

/**

 @since 10.19.0

 @see [Storybook](https://stories.core.procore.com/?path=/story/core-react_demos-input--demo)

 @see [Design Guidelines](https://design.procore.com/text-input)

 */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  function Input({ children, error, variant, ...props }, ref) {
    return (
      <StyledInput
        {...props}
        $error={error}
        $variant={variant}
        aria-invalid={error || variant === 'error' ? 'true' : 'false'}
        ref={ref}
      />
    )
  }
)

Input.displayName = 'Input'
